import env from '@utils/env'


export default (...args) => {
	if (!env.isProd && !env.isMock) {
		console.log(...args) // eslint-disable-line no-console
		return
	}
}
